import "./style.css";
import { useGeo } from "../../hooks/useGeo";
import { t } from "../../services/formatters";
import { TextInput } from "../TextInput";
import { useSession } from "../../hooks/useSession";
import { isName, isEmail, isPhone, isStringNotEmpty } from "../../services/validators";
import { useState, useEffect } from "react";
import { Suggestions } from "../Suggestions";

export const FormDatiUtenteBusiness = ({ title = "", lockFields = false, nome = "", cognome = "" }) => {
  const { read, update } = useSession();

  const [nameState, setNameState] = useState(isName(read("nome")) ? 3 : 1);
  const [surnameState, setSurnameState] = useState(isName(read("cognome")) ? 3 : 1);
  const [emailState, setEmailState] = useState(isEmail(read("email")) ? 3 : 1);
  const [phoneState, setPhoneState] = useState(isPhone(read("cellulare")) ? 3 : 1);
  const [cityState, setCityState] = useState(isStringNotEmpty(read("comuneResidenza")) ? 3 : 1);
  const [addressState, setAddressState] = useState(isStringNotEmpty(read("indirizzoResidenza")) ? 3 : 1);
  const [searchState, setSearchState] = useState("");
  const [suggestionsState, setSuggestionsState] = useState([]);

  const { searchAutocomplete, geolocalize, geoCode, geoDecode } = useGeo();

  const getCoords = async () => {
    const searchString = searchState;
    if(isStringNotEmpty(searchString)) {
      searchAutocomplete(searchString)
        .then((suggestions) => {
          setSuggestionsState(suggestions);
        })
    }
  }

  //Sul cambio indirizzo recupero le coordinate
  let tm;
  useEffect(() => {
    clearTimeout(t);
    tm = setTimeout(() => {
      getCoords();
    }, 800);
  }, [searchState]); 

  return (
    <div className={`section white-box input-box-component full-form`}>
      <h2>{title}</h2>
      <p className="crea-appto-error full-form-appto-error hidden">Tutti i campi vanno compilati correttamente.</p>
      <p className={`input-box-subtitle`}>&nbsp;</p>
      <TextInput
        state={nameState}
        name="nome"
        readonly={lockFields}
        placeholder={t("name")}
        value={nome || read("nome")}
        onChange={(value) => {
          setNameState(1);
          update("nome", value);
        }}
        onBlur={(value) => {
          isName(value) ? setNameState(3) : setNameState(4);
        }}></TextInput>
      <TextInput
        state={surnameState}
        name="cognome"
        readonly={lockFields}
        placeholder={t("surname")}
        value={cognome || read("cognome")}
        onChange={(value) => {
          setSurnameState(1);
          update("cognome", value);
        }}
        onBlur={(value) => {
          isName(value) ? setSurnameState(3) : setSurnameState(4);
        }}></TextInput>
      <TextInput
        state={emailState}
        type="email"
        name="email"
        placeholder={t("email")}
        value={read("email")}
        onChange={(value) => {
          setEmailState(1);
          update("email", value);
        }}
        onBlur={(value) => {
          isEmail(value) ? setEmailState(3) : setEmailState(4);
        }}></TextInput>
      <TextInput
        state={phoneState}
        name="cellulare"
        placeholder={t("tel")}
        value={read("cellulare")}
        onChange={(value) => {
          setPhoneState(1);
          update("cellulare", value);
        }}
        onBlur={(value) => {
          isPhone(value) ? setPhoneState(3) : setPhoneState(4);
        }}></TextInput>
        <TextInput
        state={cityState}
        name="comuneResidenza"
        placeholder={t("citta")}
        value={read("comuneResidenza")}
        onChange={(value) => {
          setCityState(1);
          update("comuneResidenza", value);
        }}
        onBlur={(value) => {
          isStringNotEmpty(value) ? setCityState(3) : setCityState(4);
        }}></TextInput>
        <TextInput
        state={addressState}
        name="indirizzoResidenza"
        placeholder={t("indirizzo")}
        value={read("indirizzoResidenza")}
        onChange={(value) => {
          setAddressState(1);
          update("indirizzoResidenza", value);
          setSearchState(value)
        }}
        onBlur={(value) => {
          isStringNotEmpty(value) ? setAddressState(3) : setAddressState(4);
        }}></TextInput>
        <Suggestions
          suggestions={suggestionsState}
          onSuggestionClick={(itm) => {
            const formattedAddress = itm.displayLines.join(", ");
            setAddressState(formattedAddress);
            update("indirizzoResidenza", formattedAddress);
            setSuggestionsState([]);
            isStringNotEmpty(formattedAddress) ? setAddressState(3) : setAddressState(4);
          }}
        />
    </div>
  );
};
